import { CarouselApp } from "@/components/CarouselApp";
import { permanentSample } from "@/lib/sample";

export default function Home() {
  return <CarouselApp demoPreview={permanentSample} />;
}
